import * as apiWarehouses from 'api/apiWarehouses';

export type WarehouseNameKind = 'team' | 'custom';
export type WarehouseNameMode = 'create' | 'rename';

export type WarehouseNameActionResult = {
    stat?: boolean;
    errCode?: string;
} | null;

export type WarehouseNameConfig = {
    titleKey: string;
    labelKey: string;
    successKey: string;
    duplicateKey: string;
    emptyKey: string;
    submitApi: (name: string, entityId?: number | null) => Promise<WarehouseNameActionResult>;
};

const CONFIGS: Record<WarehouseNameKind, Record<WarehouseNameMode, WarehouseNameConfig>> = {
    team: {
        create: {
            titleKey: 'createTeam.title',
            labelKey: 'createTeam.labelName',
            successKey: 'createTeam.messCreated',
            duplicateKey: 'createTeam.messDuplicate',
            emptyKey: 'createTeam.messEmpty',
            submitApi: (name) => apiWarehouses.createTeam(name),
        },
        rename: {
            titleKey: 'teamManage.renameTitle',
            labelKey: 'teamManage.renameLabel',
            successKey: 'teamManage.messRenamed',
            duplicateKey: 'createTeam.messDuplicate',
            emptyKey: 'createTeam.messEmpty',
            submitApi: (name, entityId) => apiWarehouses.renameTeam(entityId, name),
        },
    },
    custom: {
        create: {
            titleKey: 'createCustom.title',
            labelKey: 'createCustom.labelName',
            successKey: 'createCustom.messCreated',
            duplicateKey: 'createCustom.messDuplicate',
            emptyKey: 'createCustom.messEmpty',
            submitApi: (name) => apiWarehouses.createCustomWarehouse(name),
        },
        rename: {
            titleKey: 'customManage.renameTitle',
            labelKey: 'customManage.renameLabel',
            successKey: 'customManage.messRenamed',
            duplicateKey: 'createCustom.messDuplicate',
            emptyKey: 'createCustom.messEmpty',
            submitApi: (name, entityId) => apiWarehouses.renameCustomWarehouse(entityId, name),
        },
    },
};

export const getWarehouseNameConfig = (
    kind: WarehouseNameKind,
    mode: WarehouseNameMode,
): WarehouseNameConfig => CONFIGS[kind][mode];
